<template>
<div>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-pingjia" @click="evaTask" :disabled="taskRow.STATE != 3">评价</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-jieshou" @click="acceptTaskHandle" :disabled="!acceptShow">接收</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-jilu" @click="showConvertTaskDialog" :disabled="!convertShow">流转</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-28cuiban" @click="urgeTaskHandle" :disabled="!urgeShow">催办</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-zuofei" @click="cancelTaskHandle" :disabled="!cancelShow">作废</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-querenyuanzhengqueduigoutijiaochenggongwancheng" @click="completeTaskHandle" :disabled="!completeShow">完成</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-zongjie" @click="summaryTaskHandle" :disabled="!summaryShow">总结</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-dahui" @click="rebackTaskHandle" :disabled="!rebackShow">打回</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-pingjia" @click="evaluationTaskHandle" :disabled="!closeShow">关闭</el-button>
    <el-button style="font-size: 16px;" size="mini" icon="iconfont icon-task" @click="SubTask" :disabled="!subTaskShow">子任务</el-button>
    <!--针对许岳林pc调用-->
    <el-button v-if="showRelation==true" style="font-size: 16px;" size="mini" icon="iconfont icon-task" @closeDialog="closeDialog" @click="relateTaskHandle">关联主任务</el-button>
    <!--针对许岳林pc调用-->
    <evaTask ref="evaTask"></evaTask>
    <ConvertTask ref="convertControl" @convertTaskResult="$store.dispatch('changeTaskSource')"></ConvertTask>
    <CompleteTask ref="completeControl" @completeTaskResult="$store.dispatch('changeTaskSource')"></CompleteTask>
    <CreateTask ref="createControl" :taskTypeName="taskTypeName"></CreateTask>
    <evaluate ref="evaluate"></evaluate>
    <side-tags-subtask-sub-dialog ref="SideTagsSubtaskSubDialog"></side-tags-subtask-sub-dialog>
    <AuditProcessTaskDialog ref="AuditProcessTaskDialog"></AuditProcessTaskDialog>
    <summaryTaskDialog ref="summaryTaskDialog"></summaryTaskDialog>
    <AcceptTask ref="acceptTask" :taskId="curTask.ID" :serverCenterIds="serverCenterIds" @successed="$store.dispatch('changeTaskSource')"></AcceptTask>

    <el-dialog :visible.sync="relateDialogVisible" width="40%" center top="50px">
        <RelateMainTask style="margin-top: 25px;"></RelateMainTask>
    </el-dialog>
</div>
</template>

<script>
import {
    getToken
} from "../../../util/auth";
import RelateMainTask from "./RelateForMainTask.vue";
import AcceptTask from "./AcceptTask.vue";
import ConvertTask from "./ConvertTask.vue";
import evaTask from "./evaTask.vue";
import RelationTask from "./RelationTask.vue";
import evaluate from "./evaluate.vue";
import CreateTask from "../common/CreateTask.vue";
import handOverTask from "./handOverTask.vue";
import SideTagsSubtaskSubDialog from './SideTagsSubtaskSubDialog.vue'
import AuditProcessTaskDialog from './AuditProcessTaskDialog.vue'
import CompleteTask from "./CompleteTask.vue";
import summaryTaskDialog from './summaryTaskDialog.vue';
import {
    getAcceptTaskServerCenters,
    GetAllManageServerCenterByUserId,
    urgeTask,
    cancelTask,
    completeTask,
    rebackTask,
    addEvaluation,
    GetNoticeInstance,
    GetNoticeResult,
    canConvertTask,
    // summaryTask
} from "@/api/modules/basicData/task";
import {
    GetAuditProcess
} from "@/api/modules/basicData/workFlow";
import icon from "../../../components/common/icon.vue";
const cookieUser = getToken();
export default {
    name: 'Navbar',
    data() {
        return {
            relateDialogVisible: false,
            buttonSize: 'mini',
            selectRadioType: 0,
            type: this.$route.query.type || 2,
            expand: false,
            acceptShow: false, //
            convertShow: false, //
            urgeShow: false, //
            cancelShow: false, //
            completeShow: false, //
            rebackShow: false, //
            closeShow: false, //
            evaluateShow: false, //
            subTaskShow: false, //子任务
            subTaskFlowShow: false, //审批型子任务
            auditProcessShow: false, //审批流程
            relationShow: false, // 关联任务
            summaryShow: false, //
            curUserOnlineServerCenters: [],
            fightServerCenters: JSON.parse(localStorage.getItem('FightServerCenters')),
            curUserServerCenters: JSON.parse(localStorage.getItem('ManageServerCenter')).map(function (item) {
                return item.ID;
            }),
            myRowData: {
                userId: '',
                taskId: '',
                taskState: 1,
            },
            taskTypeName: '个人任务' //任务类型名称
        }
    },
    computed: {
        curTask: function () {
            return this.$store.state.task.curTask;
        },
        expandIcon: function () {
            return this.expand ? 'zhankai' : 'zhankai-copy';
        },
        serverCenterIds: function () {
            if (this.curUserServerCenters)
                return this.curUserServerCenters.join(',');
            else return "";
        },
        taskRow: function () {
            return this.$store.state.task.taskRow;
        },
        taskGropuParent: function () {
            return this.$store.state.task.taskGropuParent;
        },
    },
    methods: {
        evaTask() { // 评价任务
            this.$refs.evaTask.dialogVisible = true;
            this.$refs.evaTask.addValue();
        },
        handOver() {
            this.$refs.handOverTask.dialogVisible = true;
            this.$refs.handOverTask.connect();
        },
        showConvertTaskDialog() {
            canConvertTask(this.curTask.ID, cookieUser.userId, cookieUser.departmentId).then(resultCode => {
                if (resultCode < 0) {
                    this.$message.warning("当前人员不能流转");
                    return;
                } else {
                    this.$refs.convertControl.dialogVisible = true;
                }
            });
        },
        isNullOrEmptyStr(str) {
            return str == null || str === '';
        },
        isServerCenterMemeber(serverCenterId) {
            if (this.isNullOrEmptyStr(serverCenterId) || this.curUserServerCenters.length === 0)
                return false;
            return this.curUserServerCenters.indexOf(serverCenterId) > 0;
        },
        expandSearch() {
            this.expand = !this.expand;
            this.$emit("searchExpand", this.expand);
        },
        acceptTaskHandle() {
            this.$refs.acceptTask.dialogVisible = true;
        },
        urgeTaskHandle() {
            this.$prompt('请输入催办内容', '催办任务', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
            }).then(({
                value
            }) => {
                if (!value) {
                    this.$message.info("请输入催办内容");
                    return false;
                } else if (!this.trim(value)) {
                    this.$message.info("请输入催办内容");
                    return false;
                }
                urgeTask(this.curTask.ID, value, cookieUser.userId).then(resultCode => {
                    if (resultCode) {
                        this.$message.success("催办成功");
                    } else {
                        this.$message.error("催办失败");
                    }
                });
            });
        },
        cancelTaskHandle() {
            this.$confirm('确定要作废此任务?', '提示', {
                type: 'warning'
            }).then(() => {
                cancelTask(this.curTask.ID, {
                    NAME: cookieUser.realName,
                    ID: cookieUser.userId,
                    DEPTID: cookieUser.departmentId,
                    DEPTNAME: cookieUser.departmentName
                }).then(resultCode => {
                    if (resultCode) {
                        this.$message.success('作废成功');
                        this.$store.dispatch('changeTaskSource');
                    } else {
                        this.$message.error("作废任务失败");
                    }
                })
            }).catch(() => {}); //一定别忘了这个
        },
        completeTaskHandle() {
            // let completInfo={
            //   TaskId:this.curTask.ID,
            //   ServerId:this.serverCenterIds,
            //   replyContent:'',
            //   UserName:cookieUser.realName,
            //   UserId:cookieUser.userId,
            //   DeptId:cookieUser.departmentId,
            //    DeptName:cookieUser.departmentName
            // };
            // this.$refs.completeControl.dialogVisible = true;
            this.$refs.completeControl.openDialog()
            // completeTask(completInfo).then(resultMsg=>{
            //   if(resultMsg.ResultCode)
            //   {
            //     this.$message.success('完成成功');
            //     this.$store.dispatch('changeTaskSource');
            //   }else{
            //     this.$message.error("完成任务失败");
            //   }
            // });
        },
        relateTaskHandle() {
            this.relateDialogVisible = true
        },
        closeDialog() {
            this.relateDialogVisible = false
        },
        rebackTaskHandle() {
            this.$prompt('打回原因', '打回任务', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
            }).then(({
                value
            }) => {
                let rebackInfo = {
                    TaskId: this.curTask.ID,
                    ServerId: this.serverCenterIds,
                    ReplyContent: value,
                    UserName: cookieUser.realName,
                    UserId: cookieUser.userId,
                    DeptId: cookieUser.departmentId,
                    // DeptName:cookieUser.departmentName
                };
                rebackTask(rebackInfo).then(resultCode => {
                    if (resultCode) {
                        this.$message.success('打回成功');
                        this.$store.dispatch('changeTaskSource');
                    } else {
                        this.$message.error("打回任务失败");
                    }
                })
            });
        },
        evaluationTaskHandle() {
            this.$refs.evaluate.dialogVisible = true;
            this.$refs.evaluate.task = this.finishTask;
            this.$refs.evaluate.getTask();
            this.$refs.evaluate.addValue();
        },
        summaryTaskHandle() {
            // this.$refs.summaryTaskDialog.summaryTaskDialogVisible=true;
            this.$refs.summaryTaskDialog.TaskSummary();
        },
        createTask() {
            this.$refs.createControl.dialogVisible = true;
            this.$refs.createControl.title = '新建报修';
            this.$refs.createControl.workflowName = '';
            this.$refs.createControl.type = 1;
            this.$refs.createControl.processId = '';
            this.$refs.createControl.ReceiverProp = 'ReceiveUserName';
        },
        SubTask() {
            // if (this.task.STATE == 0) {
            //   this.AcceptTask(this.task);
            // };
            this.$refs.SideTagsSubtaskSubDialog.dialogFormVisible = true;
            this.$refs.SideTagsSubtaskSubDialog.type = 1;
            this.$refs.SideTagsSubtaskSubDialog.title = '新建报修';
        },
        SubFlowTask() {
            this.$refs.createControl.dialogVisible = true;
            this.$refs.createControl.title = '服务申请';
            this.$refs.createControl.workflowName = '';
            this.$refs.createControl.type = 2;
            this.$refs.createControl.processId = '';
            this.$refs.createControl.ReceiverProp = 'ReceiveUserName';
        },
        AuditProcessTask() { //审核流程事件
            this.$refs.AuditProcessTaskDialog.dialogVisible = true;
            // this.$refs.AuditProcessTaskDialog.onAuditer();
        },
        realationTask() { // 关联任务
            this.$refs.relationTask.dialogVisible = true;
        },

        selectRadioTypeChange(val) {
            this.$store.commit('setSelectRadioType', val);
        }
    },
    created() {
        // getAcceptTaskServerCenters(cookieUser.userId).then(centers => {
        // 	this.fightServerCenters = centers;
        // });
        // GetAllManageServerCenterByUserId(cookieUser.userId).then(centers => {
        // 	this.curUserServerCenters = centers.map(function(item) {
        // 		return item.ID;
        // 	});
        // })
    },
    props: {
        showRelation: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        curTask(task, oldval) {
            this.acceptShow = false; //
            this.convertShow = false; //
            this.urgeShow = false; //
            this.cancelShow = false; //
            this.completeShow = false; //
            this.rebackShow = false; //
            this.evaluateShow = false; //
            this.subTaskShow = false; //子任务
            this.subTaskFlowShow = false; //
            this.auditProcessShow = false; //审批流程
            this.summaryShow = false; //
            this.closeShow = false;
            this.relationShow = false;
            if (!task) return;
            this.subTaskShow = (task.STATE == 0 || task.STATE == 1) && ((!task.EXCUTEUSERID) ? false : (task.EXCUTEUSERID == cookieUser.userId ? true : false))
            this.subTaskFlowShow = (task.STATE == 0 || task.STATE == 1) && (task.EXCUTEUSERID == cookieUser.userId || task.CREATEUSERID == cookieUser.userId);
            switch (task.STATE) {
                case 0: //待接收 5作废  2分派子任务 1流转 0 接收
                    if (this.curUserServerCenters.length === 0) {
                        let visible = (this.isNullOrEmptyStr(task.EXCUTEUSERID) &&
                                this.fightServerCenters.indexOf(task.SERVERCENTERID) !== -1) ||
                            task.EXCUTEUSERID === cookieUser.userId;
                        this.acceptShow = visible;
                        this.convertShow = visible;
                        this.cancelShow = (task.CREATEUSERID === cookieUser.userId || visible ||
                            this.isServerCenterMemeber(task.CREATESERVERCENTERID));
                    } else {
                        if (this.isNullOrEmptyStr(task.EXCUTEUSERID)) //无接收人
                        {
                            let visible = this.isServerCenterMemeber(task.SERVERCENTERID) ||
                                (this.fightServerCenters.indexOf(task.SERVERCENTERID) !== -1);
                            this.cancelShow = task.CREATEUSERID === cookieUser.userId || visible ||
                                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
                            this.convertShow = visible;
                            this.acceptShow = visible;
                        } else {
                            let ss = task.CREATEUSERID === cookieUser.userId ||
                                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
                            this.cancelShow = task.CREATEUSERID === cookieUser.userId ||
                                this.isServerCenterMemeber(task.CREATESERVERCENTERID);
                            this.convertShow = task.EXCUTEUSERID === cookieUser.userId;
                            this.acceptShow = task.EXCUTEUSERID === cookieUser.userId;
                        }
                    }
                    this.relationShow = (task.CREATEUSERID === cookieUser.userId || task.EXCUTEUSERID === cookieUser.userId);
                    break;
                case 1: //
                    if (task.EXCUTEUSERID === cookieUser.userId) {
                        if (!task.HasSummary)
                            this.summaryShow = true; //
                        this.completeShow = true;
                        this.convertShow = true;
                    }
                    this.relationShow = (task.CREATEUSERID === cookieUser.userId || task.EXCUTEUSERID === cookieUser.userId);
                    if (task.CREATEUSERID === cookieUser.userId) this.urgeShow = true;
                    break;
                case 2:
                    this.finishTask = task;
                    if (task.CREATEUSERID === cookieUser.userId) {
                        this.rebackShow = true;
                        this.closeShow = true;
                    }
                    if (task.EXCUTEUSERID === cookieUser.userId) {
                        if (!task.HasSummary)
                            this.summaryShow = true; //
                    }
                    break;
                case 4:
                    //处理审批流程按钮权限
                    GetAuditProcess(task.WORKFLOWID, cookieUser.userId).then(res => {
                        this.auditProcessShow = res;
                    });
                    // this.auditProcessShow = true;
                    break;
                default:
                    break;
            }
        }
    },
    mounted() {
        switch (this.$route.query.type) {
            case 1:
                this.taskTypeName = '服务台任务'
                break;
            case 2:
                this.taskTypeName = '个人任务'
                break;
            case 3:
                this.taskTypeName = '任务组'
                break;
            default:
                this.taskTypeName = '个人任务'
                break
        }
    },
    components: {
        icon,
        AcceptTask,
        ConvertTask,
        CompleteTask,
        CreateTask: () => import("../common/CreateTask.vue"),
        handOverTask,
        SideTagsSubtaskSubDialog,
        evaluate,
        AuditProcessTaskDialog,
        evaTask,
        summaryTaskDialog,
        RelateMainTask
    }
}
</script>

<style scoped>

</style>
